module.exports = __webpack_public_path__ + "media/images/flags/1x1/vgb-390862c97923c6d763b9b7a5a3179c87.svg";